import ReadSmore from 'read-smore/dist/index.esm';

class ReadMoreContent extends HTMLElement {
  connectedCallback() {
    if(!this.isConnected) {
      return;
    }

    const readSmores = this.querySelectorAll('.js-read-smore');
    const maxWordCount = this.maxWordCount;

    const readSmoreOptions = {
      wordsCount: maxWordCount
    };

    ReadSmore(readSmores, readSmoreOptions).init();
  }

  get maxWordCount() {
    const wordCount = parseInt(this.dataset.maxWordCount);
    return isNaN(wordCount) ? 0 : wordCount;
  }
}

if (!window.customElements.get("read-more-content")) {
  window.customElements.define("read-more-content", ReadMoreContent);
}
